import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import type { ItemTypeLevel } from '@/common/api/types/itemType';
import { itemTypeLevelsQueryOptions } from '@/common/queries/useItemTypeLevelsQuery';
import { commonQueryKeys } from '@/common/queryKeys/common';
import { usePublishedContext } from '@/features/views/components/published/PublishedContext';
import { usePublishedSnapshotQuery } from '@/features/views/components/published/usePublishedSnapshotQuery';

export const useItemTypeLevelsQueryWithPublished = (
  options: Partial<UseQueryOptions<ItemTypeLevel[]>> = {},
) => {
  const publishedContext = usePublishedContext();
  const isPublished = publishedContext !== null;

  const levelsQuery = useQuery({
    ...itemTypeLevelsQueryOptions(),
    ...options,
    enabled: !isPublished && options.enabled !== false,
  });

  const publishedQuery = usePublishedSnapshotQuery({
    baseKey: commonQueryKeys.itemTypeLevels.all,
    getSnapshot: () => publishedContext?.itemTypeLevels,
  });

  return isPublished ? publishedQuery : levelsQuery;
};
